export default "__VITE_ASSET__2WhPW_rw__"